import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const RelatedArticleLinksCCD: IClientComponentDefinition = {
  name: 'relatedArticleLinks',
  load: () => import(/* webpackChunkName: 'relatedArticleLinks' */ './index'),
}
